export default __webpack_public_path__ + "static/media/AKASH PATIL.a9ebaeb0.jpg";